import { useModals } from '@any-ui-react/modals';
import type { ReactNode } from 'react';
import { v4 as uuid } from 'uuid';

import type { EmployeeDependentType } from '@/common/types';

import { DependentForm } from './DependentForm';

export const DependentModal = ({
  children,
  onSuccess,
  dependent,
  className,
  isNewRecord = false,
}: {
  children: ReactNode;
  onSuccess: (data: EmployeeDependentType) => void;
  dependent?: EmployeeDependentType;
  className?: string;
  isNewRecord?: boolean;
}) => {
  const modalId = uuid();
  const { openModal, closeModal } = useModals();

  const onClick = () => {
    openModal({
      modalId,
      closeOnClickOutside: false,
      closeOnEscape: false,
      withinPortal: false,
      centered: true,
      title: `${!isNewRecord ? 'Update' : 'Add New'} Dependent Information`,
      size: 'lg',
      children: (
        <DependentForm
          dependent={dependent}
          onCancel={() => closeModal(modalId)}
          onSuccess={data => {
            onSuccess(data);
            closeModal(modalId);
          }}
        />
      ),
    });
  };

  return (
    <span className={className} onClick={onClick}>
      {children}
    </span>
  );
};
